// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1asFP","header":"Messages_header__1jPCm"};